module.exports = __webpack_public_path__ + "img/icon8.b0f938c7.svg";